document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  const stockMessage = document.querySelector('#stock-message');

  if (!variant || !stockMessage) return;

  if (variant.inventory_quantity === 0) {
    stockMessage.innerHTML = `
      {% render 'icon-alert' %}
      <span class="stock-text">{{ product.metafields.custom.out_of_stock_message | escape }}</span>
    `;
  } else {
    stockMessage.innerHTML = `
      {% render 'icon-checkmark' %}
      <span class="stock-text">{{ product.metafields.custom.in_stock_message | escape }}</span>
    `;
  }
});